import React from "react";
import {
  Star,
  TrendingUp,
  ShieldCheck,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { useCarouselWindow } from "./useCarouselWindow";

const traders = [
  {
    id: "trader1",
    name: "Alex Morgan",
    country: "U.K.",
    rating: 4.9,
    verified: true,
    avatar: "/assets/traders/trader12.jpg",
    roi: "+124%",
    winRate: "68%",
    markets: "Forex, Gold",
  },
  {
    id: "trader9",
    name: "Daniel David",
    country: "U.K.",
    rating: 4.9,
    verified: true,
    avatar: "/assets/traders/trader11.jpg",
    roi: "+124%",
    winRate: "68%",
    markets: "Forex, Gold",
  },
  {
    id: "trader2",
    name: "Wayne Rhods",
    country: "South Africa",
    rating: 4.8,
    verified: true,
    avatar: "/assets/traders/trader2.jpg",
    roi: "+98%",
    winRate: "65%",
    markets: "Indices, Forex",
  },
  {
    id: "trader3",
    name: "Sophia Smith",
    country: "Spain",
    rating: 4.7,
    verified: true,
    avatar: "/assets/traders/trader3.jpg",
    roi: "+110%",
    winRate: "70%",
    markets: "Crypto, Forex",
  },
  {
    id: "trader4",
    name: "Imran Kaif",
    country: "Kenya",
    rating: 4.9,
    verified: true,
    avatar: "/assets/traders/trader4.jpg",
    roi: "+142%",
    winRate: "72%",
    markets: "Gold, Commodities",
  },
  {
    id: "trader5",
    name: "Mohammed Sultan",
    country: "U.S.",
    rating: 4.6,
    verified: true,
    avatar: "/assets/traders/trader5.jpg",
    roi: "+87%",
    winRate: "63%",
    markets: "Stocks, Indices",
  },
  {
    id: "trader6",
    name: "Inez Gordon",
    country: "Brazil",
    rating: 4.8,
    verified: true,
    avatar: "/assets/traders/trader6.jpg",
    roi: "+105%",
    winRate: "69%",
    markets: "Forex, Oil",
  },
  {
    id: "trader7",
    name: "Chen Wei",
    country: "Hong Kong",
    rating: 4.7,
    verified: true,
    avatar: "/assets/traders/trader7.jpg",
    roi: "+92%",
    winRate: "66%",
    markets: "Indices, FX",
  },
  {
    id: "trader8",
    name: "Robinson Edward",
    country: "Tanzania",
    rating: 4.6,
    verified: true,
    avatar: "/assets/traders/trader8.jpg",
    roi: "+89%",
    winRate: "64%",
    markets: "Forex, Metals",
  },
];

export default function TopTraders() {
  const VISIBLE = 4;

  const { window, next, prev, pause, resume } = useCarouselWindow({
    total: traders.length,
    visible: VISIBLE,
    auto: true,
    interval: 3200,
  });

  return (
    <section className="w-full bg-[#0B0F19] py-20">
      <div className="mx-auto max-w-6xl px-4">
        {/* Header */}
        <div className="mb-10 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-white sm:text-2xl lg:text-3xl">
              Top Performing <span className="text-blue-600">Traders</span>
            </h2>
            <p className="mt-1 text-sm text-gray-400 sm:text-base">
              Verified & Consistent Market Performers
            </p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={prev}
              className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
            >
              <ChevronLeft />
            </button>
            <button
              onClick={next}
              className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
            >
              <ChevronRight />
            </button>
          </div>
        </div>

        {/* Dark Container */}
        <div className="rounded-3xl border border-white/5 bg-[#0B0F19] px-6 py-12 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
          <div
            onMouseEnter={pause}
            onMouseLeave={resume}
            className="flex gap-8 overflow-x-hidden"
          >
            {window.map((i) => {
              const t = traders[i];
              return (
                <div
                  key={t.id}
                  className="min-w-[260px] rounded-3xl border border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] transition-all duration-300 hover:-translate-y-1 hover:border-blue-500/40"
                >
                  {/* Avatar */}
                  <div className="flex h-44 items-center justify-center">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-42 h-36 rounded-2xl border-2 border-blue-500/40 object-cover object-top"
                    />
                  </div>

                  {/* Info */}
                  <div className="px-5 py-5 text-sm text-gray-400">
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg font-semibold text-white">
                        {t.name}
                      </h3>
                      <div className="flex items-center text-yellow-400">
                        <Star size={16} fill="currentColor" />
                        <span className="ml-1 text-white">{t.rating}</span>
                      </div>
                    </div>

                    {t.verified && (
                      <div className="mt-2 flex items-center gap-1 text-xs text-blue-400">
                        <ShieldCheck size={14} />
                        Verified Trader
                      </div>
                    )}

                    <div className="mt-3 space-y-1 text-xs">
                      <div className="flex items-center gap-1">
                        <TrendingUp size={14} />
                        ROI: {t.roi}
                      </div>
                      <div>Win Rate: {t.winRate}</div>
                      <div>Markets: {t.markets}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
